import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import SubStages from './SubStages';
import { getTheme } from '../../../../../actions';
import './rootOfStages.scss';
import AddAsset from './SubStages/AddAsset';
import funcTranslateHelper from '../../../../../i18next/funcTranslateHelper';

export default function RootOfStages ({ stages, assets, configFile, setConfigFile, setOpenNotication }) {
  const disableBuilder = configFile.disableBuilder;

  return (
    <Box borderColor='white' border={0} borderRadius={0}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Typography
          align='left'
          style={{
            fontFamily: 'Roboto-Medium',
            fontWeight: '500',
            fontSize: '20px',
            color: 'rgba(0,0,0,0.87)',
            textTransform: 'capitalize'
          }}
        >
          {funcTranslateHelper(stages.name)}
        </Typography>
        {!disableBuilder &&
          <AddAsset
            setOpenNotication={setOpenNotication}
            stage={stages}
            configFile={configFile}
            setConfigFile={setConfigFile}
          />}
      </div>
      <div
        id='scroll'
        style={{
          overflowY: 'auto',
          overflowX: 'hidden',
          height: '70vh',
          backgroundColor: '#F4F4F4'
        }}
      >
        {stages.stages &&
          stages.stages.map((stage, i) => (
            <Box
              key={i}
              borderColor={getTheme().palette.primary.dark}
              border={0}
              borderRadius={0}
              width='none'
              style={{
                paddingTop: 4,
                paddingBottom: 14,
                paddingLeft: 14,
                paddingRight: 14,
                scroll: 'visible'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-around'
                }}
              >
                <SubStages
                  stages={stage}
                  key={i}
                  assets={assets}
                  configFile={configFile}
                  setConfigFile={setConfigFile}
                />
              </div>
            </Box>
          ))}
      </div>
    </Box>
  );
}
